export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
}

export interface LoggerOptions {
  level?: LogLevel
  prefix?: string
  enableConsole?: boolean
}

export class Logger {
  private static instance: Logger
  private level: LogLevel
  private prefix: string
  private enableConsole: boolean

  constructor(options: LoggerOptions = {}) {
    this.level = options.level || LogLevel.DEBUG
    this.prefix = options.prefix || 'SeaartSDK'
    this.enableConsole = options.enableConsole ?? true
  }

  public static getInstance(options?: LoggerOptions): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger(options)
    }
    return Logger.instance
  }

  public debug(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.DEBUG)) {
      this.log(LogLevel.DEBUG, message, ...args)
    }
  }

  public info(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.INFO)) {
      this.log(LogLevel.INFO, message, ...args)
    }
  }

  public warn(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.WARN)) {
      this.log(LogLevel.WARN, message, ...args)
    }
  }

  public error(message: string, ...args: any[]): void {
    if (this.shouldLog(LogLevel.ERROR)) {
      const error = new Error(message)

      try {
        if (Error.captureStackTrace) {
          Error.captureStackTrace(error, this.error)
        }
      } catch (error) {}

      this.log(LogLevel.ERROR, error, ...args)
    }
  }

  private shouldLog(level: LogLevel): boolean {
    const levels = Object.values(LogLevel)
    return levels.indexOf(level) >= levels.indexOf(this.level)
  }

  private log(level: LogLevel, message: string | Error, ...args: any[]): void {
    if (!this.enableConsole) return

    // const timestamp = new Date().toISOString()
    // let msg = message
    // let error = null
    // if (message instanceof Error) {
    //   msg = message.message
    //   error = message
    //   error.message = ''
    // }
    let logTag = `%c【${this.prefix}】`

    switch (level) {
      case LogLevel.DEBUG:
        console.debug(logTag, 'background:rgb(255, 255, 255); color:rgb(148, 114, 0);', message, ...args)
        break
      case LogLevel.INFO:
        console.log(logTag, 'background:rgb(29, 83, 177); color:rgb(196, 201, 219);', message, ...args)
        break
      case LogLevel.WARN:
        console.log(logTag, 'background:rgb(151, 118, 1); color:rgb(214, 219, 196);', message, ...args)
        break
      case LogLevel.ERROR:
        console.log(logTag, 'background:rgb(177, 39, 29); color: #dbc6c4;', message, '\n', ...args)
        break
    }
  }
}
